import { SuperAdminNotificationsState } from './types';

export const initialState: SuperAdminNotificationsState = {
  superAdminNotifications: [],
};
